export default __webpack_public_path__ + "static/media/group-icon.eb091f42.svg";